const SEASON_PATTERN = /^([A-Za-z]{2})(\d{2})$/;

/**
 * Formats a compact season string (e.g. `ES26`, `IN27`) into the
 * user-facing "Season Year + Season Code" label (e.g. `2026 ES`, `2027 IN`).
 *
 * Returns the input unchanged if it doesn't match the expected 2-letter
 * code + 2-digit year shape (empty string, not yet loaded, unexpected data).
 */
export function formatSeasonLabel(season: string | null | undefined): string {
  if (!season) return season ?? '';

  const match = SEASON_PATTERN.exec(season.trim());
  if (!match) return season;

  const [, code, yearSuffix] = match;
  return `20${yearSuffix} ${code.toUpperCase()}`;
}
